import { render } from "./wSort.vue?vue&type=template&id=d317849e&ts=true"
import script from "./wSort.vue?vue&type=script&lang=ts"
export * from "./wSort.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__